import { computed, toValue, type MaybeRefOrGetter } from 'vue';

import { useMessengerUnansweredCount } from '@/entities/messenger';

import type { MenuBadge, MenuItem } from './menu-types';

import { isMenuGroup } from './menu-types';

/** Источники счётчиков включаются только для доступных пунктов, включая детей групп. */
export function useMenuBadges(items: MaybeRefOrGetter<MenuItem[]>) {
  const links = computed(() => toValue(items).flatMap((item) => (isMenuGroup(item) ? item.children : [item])));
  const { unansweredCount } = useMessengerUnansweredCount(
    computed(() => links.value.some((item) => item.badge === 'messenger-unanswered')),
  );
  const badgeCount = (item: MenuItem): number => {
    if (isMenuGroup(item)) return item.children.reduce((sum, child) => sum + badgeCount(child), 0);
    switch (item.badge) {
      case 'messenger-unanswered':
        return unansweredCount.value;
      default:
        return 0;
    }
  };
  const BADGE_LABELS: Record<MenuBadge, string> = {
    'messenger-unanswered': 'Неотвеченные диалоги',
  };
  const badgeLabel = (item: MenuItem): string =>
    `${!isMenuGroup(item) && item.badge ? BADGE_LABELS[item.badge] : 'Неотвеченные диалоги'}: ${badgeCount(item)}`;
  const formatBadgeCount = (count: number): string => (count > 99 ? '99+' : String(count));
  return { badgeCount, badgeLabel, formatBadgeCount };
}
